import { Component, Input } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { t_Version } from 'src/app/services/apiHandler/basicMachineFunctions/basic-machine-functions.service';
import { GatewayConnectionService } from 'src/app/services/apiHandler/gateway-connection/gateway-connection.service';
import { GlobalService } from 'src/app/services/helper/global-helper';
import { IconHelper } from 'src/app/services/helper/icon-helper';
import { IdleTimerService } from 'src/app/services/helper/idleTimer/idle-timer.service';
import { RoleService } from 'src/app/services/helper/role-handling-helper';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent {

  @Input() sidenav!: MatSidenav;

  toggleState: boolean = false;
  public connected: boolean = false;
  pinned: boolean = false;
  line: string = '';
  releaseClicked: boolean = false;
  versions: t_Version[] = [];
  master_sw: string = '';
  comissionEnabled: boolean = false;

  constructor(private router: Router, public iconHelper: IconHelper, public global: GlobalService, public roleService: RoleService, private apiGwConnection: GatewayConnectionService, private idleService: IdleTimerService){
    this.global.comission.subscribe({
      next: newValue => {this.comissionEnabled = newValue.enabled;}
    });
    this.global.variables.subscribe({
      next: newValue => {this.connected = newValue.connected;}
    });
    this.global.machineInfos.subscribe({
      next: newValue => {this.line = newValue.line;}
    });
    this.global.swVersion.subscribe({
      next: newValue => {
        this.versions = newValue.versions;
        this.versions.forEach((el) => {
          if (el.name.includes('Master')) {
            this.master_sw = el.version;
          }
        });
      }
    });
  }

  public switchMachine(){
    this.idleService.stopWatching();
    this.pinned = false;
    this.global.sidenav.next({pinned: this.pinned});
    this.apiGwConnection.disconnectFromGateway().subscribe();
    this.global.machineNumber.next({ number: '', id: '', series: ''});
    this.global.machineInfos.next({line: '', name: '', engine: ''});
    this.global.variables.next({ connected: false});
    this.global.swVersion.next({loaded: false, versions: []});
    this.global.comission.next({enabled: false});
    this.router.navigateByUrl("");
    this.sidenav.close();
    setTimeout(() => {
      this.global.savedParameters.next({locked: false, parameters: []});
    }, 1000);
}

  toggleStateMenu() {
    this.toggleState = !this.toggleState;
  }

  changeStateMenu(state: boolean) {
    this.toggleState = state;
  }

  handleClose() {
    if(!this.pinned) {
      this.sidenav.close();
    }
  }

  handlePin(){
    this.pinned = !this.pinned;
    this.global.sidenav.next({pinned: this.pinned});
    if(!this.pinned) {
      this.sidenav.close();
    }
  }

  handleReleaseClick() {
    this.releaseClicked = !this.releaseClicked;
  }

}
